// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".md-mermaid[data-v-5be5c524]{margin:.4em 0;width:100%}.md-mermaid-canvas[data-v-5be5c524]{overflow-x:auto}.md-mermaid-error[data-v-5be5c524]{display:flex;align-items:center;gap:.4em;padding:.6em .8em;border:1px solid #f1c40f;background:#fffbea;border-radius:6px;color:#92720a;font-size:.85rem}", ""]);
// Exports
module.exports = exports;
